module.exports = __webpack_public_path__ + "static/contents-b034f6b7f5b7cda11315476dc74a1f4f.png";